import { Link } from "react-router-dom";
import Banner from "../components/Banner";
import { useTranslation } from "react-i18next";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../components/RenderNavItem";
import {
  HomeLeftMenuList,
  ImportantInformationSliderList,
  ImportantLinksList1,
  MessageBoardList,
} from "../utils/constants";
import { useEffect, useState } from "react";
import { mainURL } from '../utils/common';
import axios from "axios";

// const ImportantInformationSlider = ({ item }) => {
//   const { t } = useTranslation();
//   return (
//     <div className="menu-slide">
//       <div className="service-item ">
//         <div className="img">
//           <img src={item.imgSrc} className="img-fluid" alt="alt" />
//         </div>
//         <div className="details position-relative">
//           <div className="icon">
//             <i className="bi bi-gear" />
//           </div>
//           <Link to={item.navLink} className="stretched-link">
//             <h3 className="fontSizeClass">{t(item.navName)}</h3>
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

const ImportantInformationSlider = ({ item }) => {
  const { t } = useTranslation();

  const content = <h3 className="fontSizeClass">{t(item.navName)}</h3>;

  return (
    <div className="menu-slide">
      <div className="service-item">
        <div className="img">
          <img src={item.imgSrc} className="img-fluid" alt={t(item.navName)} />
        </div>

        <div className="details position-relative">
          <div className="icon">
            <i className="bi bi-gear" />
          </div>

          {item.linkType === "external" ? (
            <a
              href={item.navLink}
              className="stretched-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {content}
            </a>
          ) : (
            <Link to={item.navLink} className="stretched-link">
              {content}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

const MessageBoardItem = ({ issuingmonth, issuingdate, filestoreid, link, type, subjectofcircular }) => {
  const renderAction = () => {
    switch (type) {
      case "link":
        return (
          <Link className="nav-link fontSizeClass" to={link}>
            {subjectofcircular}
          </Link>
        );
      case "anchor":
        return (
          <a
            className="nav-link fontSizeClass"
            href={link}
            target="_blank"
            rel="noreferrer"
          >
            {subjectofcircular}
          </a>
        );
      default:
        return (
          <DownloadFileByFileStoreId fileStoreId={filestoreid} label={subjectofcircular} />
        );
    }
  };

  return (
    <li>
      <div className="policy-img2">
        <h4 className="fontSizeClass">{issuingmonth}</h4>
        <span className="fontSizeClass">{issuingdate}</span>
      </div>
      <div className="buy-policy-2">{renderAction()}</div>
    </li>
  );
};

const Home = () => {
  const { t } = useTranslation();

    const [messageBoardData, setMessageBoardData] = useState([]);
    useEffect(() => {
      // make api call to fetch message board data
      getMessageBoardData();
    }, []);
  
    const getMessageBoardData = async () => {
      //axios post
      const url = `${mainURL}/tender-be-service/getMsgBoardData`;
      const response = await axios.post(url,{itemInfo:{}});
      if(response.data.status !== 200) {
        setMessageBoardData([]);
      }else{
        setMessageBoardData(response.data.data);
      }
    };
    
  return (
    <>
      <Banner />
      <div className="help">
        <a href="/" className="fontSizeClass">
          <img
            src="assets/img/kmc-building-icn.png"
            alt="alt"
            className="img-fluid img"
          />
        </a>
      </div>

      <section className="scrool-message">
        <div className="container">
          <div className="span12 scroolMessage d-flex">
            <span className="fontSizeClass ">
              {t("home_banner_sliding_text")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text1")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text3")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text4")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text6")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text8")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text9")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text10")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text11")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text12")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text13")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text14")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text15")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text16")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text17")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text18")} <strong> *** </strong>&nbsp;
              {t("home_banner_sliding_text19")} <strong> *** </strong>
            </span>
          </div>
        </div>
      </section>
      <section id="clients" className="clients">
        <LeftSocialMediaIconUI />
        <div className="container aos-init aos-animate" data-aos="zoom-out">
          <div className="section-main-heading mb-4">
            <p className="main-heading-title">
              <span className="main-heading-border fontSizeClass">
                {t("top_bar_title")}
              </span>
            </p>
          </div>
          <div className="menu-slider">
            <div className="menu-slide-track">
              {ImportantInformationSliderList.map((item, index) => (
                <ImportantInformationSlider item={item} key={index} />
              ))}
              {ImportantInformationSliderList.map((item, i) => (
                <ImportantInformationSlider
                  key={`dup-${i}`}
                  item={item}
                  aria-hidden="true"
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container aos-init aos-animate" data-aos="fade-up">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-6 site-menu-div">
              <div className="site-menu min-high1">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {HomeLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-6 message-board">
              <div className="row">
                <div className="swap-div">
                  <div
                    className="col-lg-7 col-md-7 col-sm-6 text-center aos-animate message_board-card vertical-animation"
                    data-aos="fade-up"
                  >
                    <div className="whats-new">
                      <div className="section-title mes-title">
                        <h4 className="fontSizeClass">Message Board</h4>
                      </div>
                      <div className="body1-left-side title3">
                        <div className="block-hdnews">
                          <div
                            className="list-wrpaaer"
                            style={{ position: "relative", overflow: "hidden" }}
                          >
                            <ul
                              className="list-aggregate marquee-vertical"
                              style={{ animationDelay: "3s" }}
                            >
                              {messageBoardData.map((item, index) => (
                                <MessageBoardItem key={index} {...item} />
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-5 col-md-5 col-sm-6 about">
                    <div className="about-img">
                      <img
                        src="assets/img/Banner/about.png"
                        className="img-fluid"
                        alt="alt"
                      />
                    </div>
                    <div className="about-img">
                      <img
                        src="assets/img/Banner/about1.png"
                        className="img-fluid mt-2"
                        alt="alt"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 col-md-6 col-sm-6 Important-Links">
                  <section id="faq" className="faq">
                    <div className="aos-init aos-animate" data-aos="fade-up">
                      <div className="row gy-4">
                        <div className="col-lg-12 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">
                          <div className="content">
                            <h3 className="fontSizeClass">
                              {t("Important Links")}
                            </h3>
                          </div>
                          <div className="quick-part">
                            {ImportantLinksList1.map((item, index) => (
                              <a
                                className="fontSizeClass"
                                href={item.link}
                                target="_blank"
                                rel="noreferrer"
                                key={index}
                              >
                                {t(item.text)}
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                <div className="col-lg-5 col-md-6 col-sm-6 about">
                  <div className="certificate1">
                    <h3 className="fontSizeClass">{t("Important Links")}</h3>
                    <ul>
                      {[
                        {
                          link: "https://silpasathi.wb.gov.in/",
                          text: "Silpasathi",
                        },
                        {
                          link: "http://emis.wbpcb.gov.in/airquality/citizenreport.do",
                          text: "Air Quality Information System,WBPCB",
                        },
                        {
                          link: "https://bsk.wb.gov.in/citizenlogin",
                          text: "Bangla_Sahayata_Kendra_Citizen_Login",
                        },
                      ].map((item, index) => (
                        <li key={index}>
                          <a
                            className="fontSizeClass"
                            href={item.link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {t(item.text)}
                          </a>
                        </li>
                      ))}
                      <li>
                        <a
                          className="fontSizeClass"
                          href="assets/img/Blind_nvda_2019_1_1.exe"
                          download="Blind_nvda_2019_1_1.exe"
                        >
                          <i
                            className="bi bi-download"
                            target="_blank"
                            style={{ marginRight: "10px" }}
                          />
                          {t(
                            "Download NVDA for the Accessibility of Visually Challenged User"
                          )}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
